import { createContext, useContext, useState, useEffect } from "react";

export const TimezoneContext = createContext();

export const TimezoneProvider = ({ children }) => {

  const ALLOWED_TIMEZONES = [
  "Asia/Singapore",
  "Asia/Kolkata",
  "Europe/London",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
];

const storedTimezone = localStorage.getItem("timezone");
const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const defaultTimezone = ALLOWED_TIMEZONES.includes(storedTimezone)
  ? storedTimezone
  : ALLOWED_TIMEZONES.includes(browserTimezone)
  ? browserTimezone
  : "Asia/Kolkata"; // safe fallback


  const defaultFormat = localStorage.getItem("timeFormat") || "24";

  const [timezone, setTimezone] = useState(defaultTimezone);
  const [timeFormat, setTimeFormat] = useState(defaultFormat);

  useEffect(() => {
    if (timezone) localStorage.setItem("timezone", timezone);
  }, [timezone]);

  useEffect(() => {
    if (timeFormat) localStorage.setItem("timeFormat", timeFormat);
  }, [timeFormat]);

  return (
    <TimezoneContext.Provider
      value={{ timezone, setTimezone, timeFormat, setTimeFormat }}
    >
      {children}
    </TimezoneContext.Provider>
  );
};

// Custom hook
export const useTimezone = () => useContext(TimezoneContext);
